import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { useHistory, Redirect } from 'react-router-dom';
import {
  useStyles,
  ModalSubmitButton,
  ModalCancelButton
} from '../parts/cloudStorage/style/style';
import { btnColor } from '../../GlobalState';

import { createFileType } from '../../apicalls/cloud/fileType';

import { Button, Grid, Modal, TextField, Snackbar } from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  withStyles,
  Theme
} from '@material-ui/core/styles';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import NoteAddIcon from '@material-ui/icons/NoteAdd';

type TProps = {
  getAllFileTypes: any;
};

export const CreateFileTypeButtonField = (props: TProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [buttonColor] = useRecoilState(btnColor);
  // メッセージ
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { getAllFileTypes } = props;

  // モーダル開閉用
  const [openInputModal, setOpenInputModal] = useState<boolean>(false);
  const [fileTypeName, setFileTypeName] = useState<string>('');

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  // 新規作成
  const createNewFileType = (name: string) => {
    createFileType(name).then(data => {
      if (data === 'Not logged in!') {
        <Redirect to='/' />;
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              history.push('/filetypes');
              setOpenInputModal(false);
              getAllFileTypes();
            }, 2000);
          }
        }
      }
    });
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          backgroundColor: '#fff',
          padding: 24
        }}
      >
        {/* 資料種別新規作成ボタン */}
        <Button
          style={{
            backgroundColor: buttonColor,
            marginBottom: 10,
            marginLeft: 15
          }}
          variant='contained'
          color='secondary'
          startIcon={<NoteAddIcon />}
          onClick={() => setOpenInputModal(true)}
        >
          新規作成
        </Button>
      </div>
      {/* 資料種別新規作成モーダル */}
      <Modal
        open={openInputModal}
        onClose={() => setOpenInputModal(false)}
        className={classes.container}
      >
        <form className={classes.paper}>
          <Grid container>
            <Grid item xs={12} style={{ padding: 36 }}>
              <div style={{ textAlign: 'center' }}>
                <h1 style={{ marginBottom: 24, fontSize: 24 }}>
                  資料種別を作成
                </h1>
                <div className={classes.container}>
                  <div style={{ marginRight: 24 }}>種別名</div>
                  <TextField
                    variant='outlined'
                    style={{ width: 360 }}
                    onChange={e => {
                      setFileTypeName(e.target.value);
                    }}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.modalFooter}>
              <ModalCancelButton
                variant='contained'
                onClick={() => {
                  setOpenInputModal(false);
                }}
              >
                キャンセル
              </ModalCancelButton>
              <ModalSubmitButton
                variant='contained'
                onClick={() => {
                  setOpenInputModal(false);
                  createNewFileType(fileTypeName);
                }}
              >
                作成する
              </ModalSubmitButton>
            </Grid>
          </Grid>
        </form>
      </Modal>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error'>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccess}
        autoHideDuration={4000}
        onClose={handleCloseSuccess}
      >
        <Alert onClose={handleCloseSuccess} severity='success'>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
